import React from "react";
import Preloader from "./components/Preloader";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Collections from "./components/Collections";
import Founder from "./components/Founder";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import MobileCallBar from "./components/MobileCallBar";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-obsidian text-ivory font-sans p-8 text-center">
                    <div>
                        <p className="font-hindi text-gold text-2xl">माँ गायत्री ज्वेलर्स</p>
                        <p className="mt-3 text-muted text-sm">Something went wrong — please reload the page.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default function App() {
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        let lenis;
        let raf;
        try {
            const Lenis = require("lenis").default;
            lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
            window.__lenis = lenis;
            const loop = (t) => {
                lenis.raf(t);
                raf = requestAnimationFrame(loop);
            };
            raf = requestAnimationFrame(loop);
        } catch (e) {
            /* native scroll fallback */
        }
        return () => {
            if (raf) cancelAnimationFrame(raf);
            if (lenis) lenis.destroy();
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="grain bg-obsidian text-ivory min-h-screen">
                <Preloader onDone={setLoaded} />
                <Nav />
                <main>
                    <Hero start={loaded} />
                    <Marquee />
                    <About />
                    <Collections />
                    <Founder />
                    <Gallery />
                    <Contact />
                </main>
                <Footer />
                <MobileCallBar />
            </div>
        </ErrorBoundary>
    );
}
